/**
 * Hunarvar – Nav Dropdown / Mega-Menu
 * Hover-Trigger fuer alle Parent-Items, mit 200ms Close-Delay.
 * Keyboard-Accessibility: Enter/Space toggelt, Tab oeffnet via focusin,
 * ESC schliesst alles.
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.nav__item--has-dropdown');
    if (!items.length) return;

    var closeTimers = new WeakMap();
    var CLOSE_DELAY = 200;

    function openItem(item, parent) {
      var t = closeTimers.get(item);
      if (t) { clearTimeout(t); closeTimers.delete(item); }
      parent.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose(item, parent) {
      var prev = closeTimers.get(item);
      if (prev) clearTimeout(prev);
      var t = setTimeout(function () {
        parent.setAttribute('aria-expanded', 'false');
        closeTimers.delete(item);
      }, CLOSE_DELAY);
      closeTimers.set(item, t);
    }

    function closeAllImmediate() {
      items.forEach(function (item) {
        var parent = item.querySelector('.nav__link--parent');
        if (!parent) return;
        var t = closeTimers.get(item);
        if (t) { clearTimeout(t); closeTimers.delete(item); }
        parent.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (item) {
      var parent = item.querySelector('.nav__link--parent');
      if (!parent) return;

      // Mouse
      item.addEventListener('mouseenter', function () { openItem(item, parent); });
      item.addEventListener('mouseleave', function () { scheduleClose(item, parent); });

      // Keyboard focus (Tab-Navigation)
      item.addEventListener('focusin', function () { openItem(item, parent); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose(item, parent);
      });

      // Enter/Space on parent toggles (fallback for touch + keyboard activation)
      parent.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = parent.getAttribute('aria-expanded') === 'true';
          if (isOpen) scheduleClose(item, parent); else openItem(item, parent);
        }
      });
    });

    // ESC schliesst alle
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllImmediate();
    });

    // Outside-Click schliesst alle (fallback)
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nav__item--has-dropdown')) closeAllImmediate();
    });
  });
})();
